import { useState } from "react";
import { Card, btnPrimary } from "../shared";

export function StripeConnectSection({ companyProfile }) {
  const [connectLoading, setConnectLoading] = useState(false);
  const [connectError,   setConnectError]   = useState(null);
  const connectStatus = companyProfile?.stripe_connect_status || null;

  const handleConnectBank = async () => {
    setConnectLoading(true);
    setConnectError(null);
    try {
      const { supabase: sb } = await import("../../supabaseClient");
      const { data: { session: sess } } = await sb.auth.getSession();
      if (!sess) { window.location.href = "/app?signin"; return; }
      const { data, error } = await sb.functions.invoke("stripe-connect-onboard");
      if (error || !data?.url) {
        setConnectError(error?.message || "Could not start Connect onboarding. Please try again.");
        return;
      }
      window.location.href = data.url;
    } catch (err) {
      setConnectError(String(err));
    } finally {
      setConnectLoading(false);
    }
  };

  return (
    <Card id="stripe-connect" style={{ marginBottom: 20 }}>
      <div style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 800, fontSize: 16, marginBottom: 6 }}>
        💰 Tenant Rent Payments
      </div>
      <div style={{ fontSize: 12, color: "#9B9690", marginBottom: 16, lineHeight: 1.6 }}>
        Connect your bank account via Stripe to accept online rent payments directly from tenants.
      </div>

      {connectStatus === "connected" ? (
        <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px", background: "#EAF2ED", border: "1px solid #C5DBC9", borderRadius: 10 }}>
          <span style={{ fontSize: 16 }}>✅</span>
          <div>
            <div style={{ fontWeight: 700, fontSize: 13, color: "#163C2F" }}>Bank account connected</div>
            <div style={{ fontSize: 12, color: "#6b7c6b" }}>Your Stripe account is active and ready to receive tenant payments.</div>
          </div>
        </div>
      ) : (
        <>
          {connectStatus === "pending" && (
            <div style={{ padding: "10px 14px", background: "#FFFBF0", borderRadius: 8, border: "1px solid #B08D5733", fontSize: 12, color: "#92400E", marginBottom: 14, lineHeight: 1.6 }}>
              ⏳ Your Stripe Connect onboarding is in progress. Click below to continue where you left off.
            </div>
          )}
          <button
            onClick={handleConnectBank}
            disabled={connectLoading}
            style={{ ...btnPrimary, opacity: connectLoading ? 0.6 : 1 }}
          >
            {connectLoading ? "Connecting..." : connectStatus === "pending" ? "Continue Setup" : "Connect Bank Account"}
          </button>
          {connectError && (
            <div style={{ marginTop: 12, padding: "10px 14px", background: "#FEF2F2", border: "1px solid #dc262622", borderRadius: 8, fontSize: 12, color: "#dc2626", lineHeight: 1.5 }}>
              {connectError}
            </div>
          )}
        </>
      )}
    </Card>
  );
}
